import React from 'react';
import DateRangeFilter from 'components/list/Filters/types/DateRangeFilter';

const DestinationDepartureFilter = <DateRangeFilter
    floatingLabelFixed={ true }
    fullWidth={ true }
    label='filters.components.destinationDepartureDate.label'
    placeholder='filters.components.destinationDepartureDate.placeholder'
    source='destination_departure_date'
/>;

export default DestinationDepartureFilter;



// WEBPACK FOOTER //
// ./src/components/form/filters/DestinationDepartureDateFilter.js